import React from "react";
import { useImagesGallery } from "@/hooks/useImagesGallery";
import isempty from "lodash/isEmpty";
import { generateUrl } from "@/utils/cloudinary";
import { useInView } from "react-intersection-observer";
import { useTaskPhotosQuery } from "./hooks/usePhotosQuery";

const TaskItemPhotos = ({ task }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
  });
  const bizTaskPhotosQuery = useTaskPhotosQuery({
    taskId: task._id,
    enabled: !task.personal && !isempty(task.photos) && inView,
    select: (photos) => photos?.filter(Boolean).map(({ photo }) => photo),
  });
  const baseOpenGallery = useImagesGallery();
  const openGallery = (activeIndex) => {
    baseOpenGallery({
      images: photos.map(generateUrl),
      activeIndex,
    });
  };
  const hasPhotos = task.personal
    ? !isempty(task.personal_photos)
    : !isempty(task.photos);
  const photos = bizTaskPhotosQuery.data || task.personal_photos;
  return (
    <div
      style={{
        margin: hasPhotos ? "5px 0" : 0,
        height: hasPhotos ? "42px" : "1px",
      }}
      ref={ref}
    >
      {!isempty(photos) && inView && (
        <div
          css={`
            display: flex;
            align-items: center;
            img {
              cursor: pointer;
              margin-right: 5px;
              --size: 40px;
              border-radius: 50%;
              object-fit: cover;
              width: var(--size);
              height: var(--size);
              min-height: var(--size);
              min-width: var(--size);
            }
          `}
        >
          {photos.map((photo, idx) => (
            <img
              role="button"
              onClick={() => openGallery(idx)}
              key={idx}
              src={generateUrl(photo, {
                width: 100,
                height: 100,
                crop: "fill",
              })}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default TaskItemPhotos;
